<div class="page-layout blank py-8 px-24" fusePerfectScrollbar>
  <ng-container *ngIf="order?.SG_ORDERID">
    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutGap="0px"
      fxLayoutGap.gt-xs="20px"
      class="mb-12"
    >
      <div fxFlex>
        <p>
          <span>{{ tenantConfig.sName }} Shipping ID: </span>
          <span>{{ order.SG_ORDERID }}</span>
        </p>
        <p *ngIf="order.onlinePlatformName">
          <span>Channel Name: </span>
          <span>{{ order.onlinePlatformName | titlecase }}</span>
        </p>
      </div>
      <div fxFlex>
        <p>
          <span>Order Total: </span>
          <span>
            {{ order.orderTotal | RupeePaise: "rupee" | currency: "INR" }}
          </span>
        </p>
      </div>
    </div>

    <div class="border border-radius-4 py-4 px-8 table-bdr">
      <table>
        <tr>
          <th>#</th>
          <th>Item Name</th>
          <th>Item SKU</th>
          <th>Item Price</th>
          <th>Item Quantity</th>
        </tr>
        <tr *ngFor="let item of order.items; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.sku }}</td>
          <td>
            {{ item.price | RupeePaise: "rupee" | currency: "INR" }}
          </td>
          <td>{{ item.quantity }}</td>
        </tr>
      </table>
    </div>

    <!-- Reverse QC Information -->
    <div *ngIf="reverseQCEnabled" class="mt-24 mb-24">
      <h3 class="accent-fg text-uppercase font-weight-600 text-italic mb-0">
        REVERSE QC DETAILS
      </h3>

      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxLayoutGap="0px"
        fxLayoutGap.gt-xs="20px"
        class="mb-12 mt-16"
      >
        <div fxFlex>
          <p>
            <span>Reverse QC: </span>
            <span class="font-weight-600">Enabled</span>
          </p>
          <p>
            <span>Return Reason: </span>
            <span>{{ reverseQCForm?.value?.return_reason }}</span>
          </p>
        </div>
        <div fxFlex>
          <p>
            <span>RVP Type: </span>
            <span>{{ formatRvpType(reverseQCForm?.value?.rvp_type) }}</span>
          </p>
        </div>
      </div>

      <div class="border border-radius-4 py-4 px-8 table-bdr mt-12">
        <table>
          <tr>
            <th>#</th>
            <th>Product Name</th>
            <th>Brand</th>
            <th>Size</th>
            <th>Color</th>
            <th>IMEI</th>
            <th>Serial No</th>
            <th>EAN Barcode</th>
            <th>Quantity</th>
            <th>Images</th>
          </tr>
          <tr *ngFor="let item of getItemsForDisplay(); let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.product_name || item.name }}</td>
            <td>{{ item.brand || "-" }}</td>
            <td>{{ item.size || "-" }}</td>
            <td>{{ item.color || "-" }}</td>
            <td>{{ item.imei || "-" }}</td>
            <td>{{ item.serial_no || "-" }}</td>
            <td>{{ item.ean_barcode || "-" }}</td>
            <td>{{ item.quantity || 1 }}</td>
            <td style="pointer-events: auto !important;">
              <ng-container *ngIf="item.product_images?.length > 0; else noImages">
                <button
                  mat-button
                  color="primary"
                  class="image-count-link"
                  (mouseup)="$event.stopPropagation(); $event.preventDefault(); openImageModal(item.product_images)"
                  (click)="$event.stopPropagation(); $event.preventDefault()"
                  type="button"
                  title="Click to view image links"
                >
                  {{ item.product_images.length }}
                </button>
              </ng-container>
              <ng-template #noImages>
                <span style="color: #999;">0</span>
              </ng-template>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <h3 class="accent-fg text-uppercase font-weight-600 text-italic mb-0">
      WEIGHT AND DIMENSIONS
    </h3>

    <div class="border border-radius-4 py-4 px-8 table-bdr mt-20">
      <table>
        <tr>
          <th>#</th>
          <th>Length</th>
          <th>Breadth</th>
          <th>Height</th>
          <th>Weight</th>
        </tr>
        <tr>
          <td>1</td>
          <td>{{ order.shipping_info?.size?.length }} cm</td>
          <td>{{ order.shipping_info?.size?.breadth }} cm</td>
          <td>{{ order.shipping_info?.size?.height }} cm</td>
          <td>
            {{ order.shipping_info?.weight | weightConversionTo: "kg" }} Kg
          </td>
        </tr>
      </table>
    </div>

    <h3 class="accent-fg text-uppercase font-weight-600 text-italic mb-0">
      COURIER PARTNER
    </h3>

    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutGap="0px"
      fxLayoutGap.gt-xs="20px"
      class="mb-12"
    >
      <div fxFlex>
        <div
          *ngIf="
            courierPartnerForm.get('courier').value?.price?.courierObj
              ?.courierIdentifier
          "
          class="mt-16"
        >
          <img
            class="w-80"
            src="assets/images/couriers/{{
              courierPartnerForm.get('courier').value?.price?.courierObj
                ?.courierIdentifier
            }}.png"
            alt="Courier Logo"
          />
        </div>
        <p>
          <span> Service: </span>
          <span>
            {{
              courierPartnerForm.get("courier").value?.price?.courierObj
                ?.service ||
                courierPartnerForm.get("courier").value?.price?.courierObj
                  ?.courier_service
            }}
          </span>
        </p>
        <p ngClass.lt-sm="mb-0">
          <span> Shipping Charge: </span>
          <span>
            {{
              courierPartnerForm.get("courier").value?.price?.price
                | RupeePaise: "rupee"
                | currency: "INR"
            }}
          </span>
        </p>
      </div>

      <div fxFlex>
        <p>
          <span> Charged Weight: </span>
          <span>
            {{
              courierPartnerForm.get("courier").value?.price?.deadWeight >
              courierPartnerForm.get("courier").value?.price?.volWeight
                ? (courierPartnerForm.get("courier").value?.price?.deadWeight
                  | weightConversionTo: "kg")
                : (courierPartnerForm.get("courier").value?.price?.volWeight
                  | weightConversionTo: "kg")
            }}
            Kg
          </span>
        </p>
        <p>
          <span> Weight Category: </span>
          <span>
            {{
              weightCategory[
                courierPartnerForm.get("courier").value?.price?.charged
              ]
            }}
          </span>
        </p>
      </div>
    </div>

    <div
      fxLayout="row"
      fxLayout.lt-sm="column"
      fxLayoutGap="0px"
      fxLayoutGap.gt-xs="20px"
      class="border border-radius-4 px-12 py-4"
    >
      <div fxFlex>
        <h3 class="accent-fg text-uppercase font-weight-600 text-italic">
          PICKUP ADDRESS
        </h3>

        <div>
          <p>
            {{ order.shipping_info?.pickup_address?.name }}
          </p>
          <p>
            {{ order.shipping_info?.pickup_address?.phone }}
          </p>
          <p>
            {{ order.shipping_info?.pickup_address?.line1 }},
            {{ order.shipping_info?.pickup_address?.line2 }}
          </p>
          <p>
            {{ order.shipping_info?.pickup_address?.city }},
            {{ order.shipping_info?.pickup_address?.state }} -
            {{ order.shipping_info?.pickup_address?.pincode }}
          </p>
        </div>
      </div>

      <div fxFlex>
        <h3 class="accent-fg text-uppercase font-weight-600 text-italic">
          DELIVERY ADDRESS
        </h3>
        <div>
          <p>{{ order.firstName }} {{ order.lastName }}</p>
          <p>
            {{ order.email }}
          </p>
          <p>
            {{ order.phone }}<span *ngIf="order.alternatePhone">,</span>
            {{ order.alternatePhone }}
          </p>
          <p>{{ order.addressLine1 }}, {{ order.addressLine2 }}</p>
          <p>{{ order.city }}, {{ order.state }} - {{ order.pincode }}</p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
